import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StudyInstance } from '../../objects/study-instance';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { InstanceService } from '../../services/instance.service';
import { ClientEventService } from '@radsource/ng-common-lib';
import { ToDicomNamePipe } from '../../pipes/to-dicom-name.pipe';
import { FromDicomNamePipe } from '../../pipes/from-dicom-name.pipe';

import { MatSnackBar } from '@angular/material';

//This is a dependency of the Proton Xpress App Module
@Component({
  selector: 'edit-study',
  templateUrl: './edit-study.component.html',
  styleUrls: ['./edit-study.component.scss']
})
export class EditStudyComponent implements OnInit, OnChanges {

  @Input() study: StudyInstance;
  organizationCode: string = "";
  errorText: string = null;
  deleting: Boolean = false;

  studyForm: FormGroup;

  fromDCPipe = new FromDicomNamePipe();
  toDCPipe = new ToDicomNamePipe();

  physNameArr: Array<string> = new Array<string>();
  risID: string = "";
  prefix: string = "";
  firstName: string = "";
  middleName: string = "";
  lastName: string = "";
  suffix: string = "";

  studyDescription: string = "";
  accessionNumber: string = "";

  showReset: Boolean = false;

  referringPhysicianName: string = "";

  nameRegex: string = "[a-zA-Z0-9., ]*"

  constructor(
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private is: InstanceService,
    private ces: ClientEventService
  ) { }

  ngOnInit() {
    this.initStudyForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initStudyForm();
  }

  clearStudyForm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.studyForm.reset();
    this.showReset = true;
  }

  revertStudyForm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.showReset = false;
    this.initStudyForm();
  }

  initStudyForm() {
    this.physNameArr = [];
    if (this.study) {
      if (this.study.referring_physician) {
        if (this.study.referring_physician.length > 0) {
          this.physNameArr = this.fromDCPipe.transform(
            this.study.referring_physician,
            true,
            true
          );
          this.risID = (this.physNameArr[0]) ? this.physNameArr[0] : "";
          this.lastName = (this.physNameArr[1]) ? this.physNameArr[1] : "";
          this.firstName = (this.physNameArr[2]) ? this.physNameArr[2] : "";
          this.middleName = (this.physNameArr[3]) ? this.physNameArr[3] : "";
          this.prefix = (this.physNameArr[4]) ? this.physNameArr[4] : "";
          this.suffix = (this.physNameArr[5]) ? this.physNameArr[5] : "";
        }
      }

      this.studyDescription = (this.study.description) ? this.study.description : "";
      this.accessionNumber = (this.study.accession_number) ? this.study.accession_number : "";

      this.studyForm = this.fb.group({
        studyDescription: this.studyDescription,
        accessionNumber: this.accessionNumber,
        risID: new FormControl( this.risID,),
        prefix: new FormControl( this.prefix,),
        firstName: new FormControl( this.firstName,),
        middleName: new FormControl( this.middleName,),
        lastName: new FormControl( this.lastName,),
        suffix: new FormControl( this.suffix,)
      });
      this.parseName();
      this.studyForm.valueChanges.subscribe(val => {
        this.parseName();
      });
    }
  }
  
  applyForm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.study.description = this.studyForm.controls.studyDescription.value;
    this.study.accession_number = this.studyForm.controls.accessionNumber.value;
    this.study.referring_physician = this.referringPhysicianName;
    this.saveEdit();
  }

  saveEdit(): any {
    this.is.patientEditing$.emit(false);
    let patientInd = this.is.patients.findIndex((p) => p.record_id == this.study.patient_record_id);
    let studyInd = this.is.patients[patientInd].studies.findIndex((s) => s.record_id == this.study.record_id);
    this.is.patients[patientInd].studies[studyInd].editing = false;
    this.is.patients[patientInd].studies[studyInd].saving = true;
    this.is.updateStudyAsOwner(this.study)
      .then((res) => {
        this.snackBar.open("Study Updated", null, {
          duration: 1000,
        });
      }).catch((err) => {
        this.errorText = err;
      });
  }

  closeEdit() {
    this.study.editing = false;
    this.study.editTemplate = false;
  }

  revertStudyDescription() {
    this.studyForm.controls.studyDescription.setValue(this.studyDescription);
  }

  revertAccessionNumber() {
    this.studyForm.controls.accessionNumber.setValue(this.accessionNumber);
  }

  revertRISID() {
    this.studyForm.controls.risID.setValue(this.risID);
  }

  revertFirstName() {
    this.studyForm.controls.firstName.setValue(this.firstName);
  }

  revertMiddleName() {
    this.studyForm.controls.middleName.setValue(this.middleName);
  }

  revertLastName() {
    this.studyForm.controls.lastName.setValue(this.lastName);
  }

  revertPrefix() {
    this.studyForm.controls.prefix.setValue(this.prefix);
  }

  revertSuffix() {
    this.studyForm.controls.suffix.setValue(this.suffix);
  }

  parseName() {
    this.physNameArr[0] = this.studyForm.controls.risID.value;
    this.physNameArr[1] = this.studyForm.controls.lastName.value;
    this.physNameArr[2] = this.studyForm.controls.firstName.value;
    this.physNameArr[3] = this.studyForm.controls.middleName.value;
    this.physNameArr[4] = this.studyForm.controls.prefix.value;
    this.physNameArr[5] = this.studyForm.controls.suffix.value;
    this.referringPhysicianName = this.toDCPipe.transform(this.physNameArr);
  }

}
